import axios, { AxiosError } from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5005/api",
  withCredentials: true,
  timeout: 15000,
});

export function isServerUnavailableError(error: unknown): boolean {
  if (!axios.isAxiosError(error)) return false;
  if (error.code === "ERR_CANCELED") return false;

  const status = error.response?.status;
  if (typeof status === "number" && status >= 500) return true;

  return !error.response;
}

type ServerUnavailableHandler = () => void;

let serverUnavailableHandler: ServerUnavailableHandler | null = null;
let lastHandledAt = 0;
const HANDLE_COOLDOWN_MS = 2000;

export function setServerUnavailableHandler(
  handler: ServerUnavailableHandler | null,
) {
  serverUnavailableHandler = handler;
}

axiosInstance.interceptors.response.use(
  (response) => {
    lastHandledAt = 0;
    return response;
  },
  (error: AxiosError) => {
    if (isServerUnavailableError(error)) {
      const now = Date.now();
      if (now - lastHandledAt > HANDLE_COOLDOWN_MS) {
        lastHandledAt = now;
        serverUnavailableHandler?.();
      }
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
